import { CatalogueRepository } from "@catalogue/data/repositories/catalogue.repository";
import { Derivation } from "@catalogue/domain/models/derivation.model";
import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";

@injectable()
export class GetDerivationByIdUseCase {
    constructor(
        @inject(CatalogueRepository)
        private readonly catalogueRepository: CatalogueRepository,
    ) { }

    async execute(derivationId: number): Promise<Nullable<Derivation>> {
        const result = await this.catalogueRepository.getDerivationById(derivationId);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        return result.fold(
            () => null,
            (derivation) => derivation
        );
    }
}